<template>
  <div class="application-scenario-container">
    <div class="pc d-none d-lg-block">
      <p class="title">应用场景</p>
      <div class="container" data-aos="fade-left" :data-aos-duration="1 * 1000">
        <div class="left">
          <img src="https://zealcomm-site-assets.zealcomm.cn/new-product/intelligent-recording.png" alt="" />
        </div>
        <div class="right">
          <p class="intelligent-double-recording">智能双录</p>
          <p class="subtitle">
            为金融客户提供线上远程双录、AI自助双录、线下柜面双录<br />等，赋能如坐席客服、金融放贷、证券开户等多种场景适<br />配，满足业务留痕、回溯的监管要求。
          </p>
          <p class="btn-text" @click="open">了解更多 →</p>
        </div>
      </div>
    </div>
    <div class="d-lg-none mobile">
      <p class="title">应用场景</p>
      <div class="container" data-aos="fade-left" :data-aos-duration="1 * 1000">
        <div class="top">
          <p class="intelligent-double-recording">智能双录</p>
          <p class="subtitle">
            为金融客户提供线上远程双录、AI自助双录、线下柜面双录等，赋能如坐席客服、金融放贷、证券开户等多种场景适配，满足业务留痕、回溯的监管要求。
          </p>
          <p class="btn-text" @click="open">了解更多 →</p>
        </div>
        <div class="bottom">
          <img src="~assets/img/solution/intelligent-mobile.png" alt="" />
        </div>
      </div>
    </div>
    <Form v-model="show" />
  </div>
</template>

<script>
  import Form from "@/components/Form/index.vue";
  export default {
    data() {
      return {
        show: false,
      };
    },
    components: {
      Form,
    },
    methods: {
      open() {
        if (typeof this.customBtnClick === "function") {
          this.customBtnClick.call();
        } else {
          this.show = true;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .pc {
    @import "./title.scss";
    .title {
      @extend %title;
      margin-top: 90px;
    }
    .container {
      display: flex;
      justify-content: space-between;
      padding: 80px 0 82px;

      .left {
        flex: 1;
        img {
          width: 417px;
          height: 337px;
        }
      }

      .right {
        flex: 1;
        font-family: PingFangSC-Medium, PingFang SC;
        color: #363636;
        margin: 35px 0 0 170px;
        .intelligent-double-recording {
          font-size: 30px;
          font-weight: 500;
        }
        .subtitle {
          text-align: left;
          margin-top: 32px;
          font-size: 18px;
          font-weight: 400;
        }
        .btn-text {
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #08c6ad;
          cursor: pointer;
          margin-top: 45px;
        }
      }
    }
  }
  .mobile {
    @import "./mobileTitle.scss";
    .title {
      @extend %mobileTitle;
      margin-top: 30px;
    }
    .container {
      padding: 41px 0 40px;
      .top {
        font-family: PingFangSC-Medium, PingFang SC;
        color: #363636;
        margin-left: 20px;
        .intelligent-double-recording {
          font-size: 18px;
          font-weight: 500;
        }
        .subtitle {
          text-align: left;
          font-size: 13px;
          font-weight: 400;
          padding: 18px 41px 0 0;
        }
        .btn-text {
          width: 102px;
          height: 24px;
          border-radius: 3px;
          border: 1px solid #0ab49e;
          margin-top: 16px;
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #08c6ad;
          text-align: center;
        }
      }
      .bottom {
        margin: 30px 31px 0 30px;
        img {
          width: 314px;
          height: 254px;
        }
      }
    }
  }
</style>
